{
  "Seguimiento del pedido": "Bestellverfolgung",
  "Enviado": "Versandt",
  "Empaquetado": "Verpackt",
  "Recibido": "Erhalten",
  "Items del pedido": "Bestellpositionen",
  "En proceso": "In Bearbeitung",
  "Devolución solicitada": "Rücksendung angefordert",
  "Devolución en proceso": "Rücksendung in Bearbeitung",
  "Devuelto": "Zurückgesendet",
  "Envío": "Sendung",
  "Devolución": "Rücksendung",
  "Ver en tienda": "Zum Geschäft gehen",
  "Solicitudes de devolución": "Rücksendeanfragen",
  "Envíos": "Sendungen",
  "Confirmado": "Bestätigt",
  "En curso": "In Bearbeitung",
  "Seguimiento de envío": "Sendungsverfolgung",
  "Destino": "Ziel",
  "Dirección destino": "Zieladresse",
  "Última actualización": "Letzte Aktualisierung",
  "Devolución pendiente": "Rücksendung ausstehend",
  "Recogida solicitada": "Abholung beantragt",
  "Devolución enviada": "Rücksendung gesendet",
  "Entrega estimada": "Voraussichtliche Lieferung",
  "Valora tu experiencia con nosotros": "Bewerten Sie Ihre Erfahrungen mit uns.",
  "¡Gracias!": "Danke!",
  "Mensaje de alerta": "Warnmeldung",
  "Punto de recogida": "Abholpunkt",
  "Mostrar historial completo": "Kompletten Verlauf anzeigen",
  "Ocultar historial": "Verlauf ausblenden",
  "¿Necesitas hacer una devolución o cambio?": "Möchten Sie etwas zurückgeben oder umtauschen?",
  "¿Quieres devolver algo más?": "Möchten Sie noch etwas zurückgeben?",
  "Devuelve o cambia tu artículo en pocos pasos.": "Geben Sie Ihren Artikel in wenigen Schritten zurück oder tauschen Sie ihn um.",
  "Empieza el proceso en pocos pasos. Te guiaremos durante todo el proceso.": "Starten Sie den Vorgang in wenigen Schritten. Wir begleiten Sie durch den gesamten Prozess.",
  "Abrir el portal de devoluciones": "Zum Rückgabeportal",
  "Enviando": "Wird gesendet",
  "¡Página no encontrada!": "Seite nicht gefunden!",
  "Lo sentimos, pero no se pudo encontrar la página que estabas buscando": "Entschuldigung, die gesuchte Seite konnte nicht gefunden werden",
  "Puedes volver al ": "Sie können zurück zum ",
  "principio": "Anfang",
  "o escribirnos a support@reveni.io si no encuentras lo que estabas buscando": "oder schreiben Sie uns an support@reveni.io, wenn Sie nicht finden, wonach Sie suchen"
}
